var _g, _g2, _path, _path2, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeetroot(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#c1274d",
    strokeWidth: 2,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 26C24 18 20 14 16 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 25C32 16 32 12 32 9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 26C40 18 44 14 48 13"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#5cb85c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 13c-6-1-10 2-11 7 6 2 11 0 15-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 9c-3-5-8-7-13-6 2 6 7 9 13 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 13c6-1 10 2 11 7-6 2-11 0-15-4z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 24c11 0 18 8 15 19-2 8-9 14-15 14s-13-6-15-14c-3-11 4-19 15-19z",
    fill: "#9d174d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 57c-1 3 0 5 0 7 0-2 1-4 0-7z",
    fill: "#9d174d"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25,
    cy: 37,
    rx: 3,
    ry: 6,
    fill: "#c9184a",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeetroot);
export default __webpack_public_path__ + "static/media/beetroot.62d3616e3928d2b0975457f50671324e.svg";
export { ForwardRef as ReactComponent };